<template>
    <b-button class="float-right"
        variant="success"
        @click.stop="inserirNovaDespesa()"
    >
        <span>
            <i class="fa fa-plus mr-2"></i> Inserir Despesa
        </span>
    </b-button>
</template>

<script>
export default {
    methods: {
        inserirNovaDespesa() {
            this.$router.push({
                name: `${this.$route.name}_Inserir`,
            })
        }
    }
}
</script>